import type { CoreApiClient } from "../client";
import { createMeshMutations } from "../mutations/mesh.mutations";
import { createMeshQueries } from "../queries/mesh.queries";

export const createMeshRepository = (api: CoreApiClient) => ({
  ...createMeshQueries(api),
  ...createMeshMutations(api),
});
